export default "__VITE_ASSET__Bjpwscl8__"